(function () {
  let isRefreshing = false;

  async function getCart() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function pickAnchorProductId(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return null;
    const last = cart.items[cart.items.length - 1];
    return last.product_id || cart.items[0].product_id || null;
  }

  async function refreshRecommendations(cartOptional) {
    if (isRefreshing) return;

    const mount = document.getElementById('CartDrawerRecommendationsMount');
    if (!mount) return;

    isRefreshing = true;

    try {
      const cart = cartOptional || (await getCart());
      const productId = pickAnchorProductId(cart);

      if (!productId) {
        mount.innerHTML = '';
        return;
      }

      const sectionId = mount.dataset.sectionId; // cart-drawer-auto-recomm
      const limit = mount.dataset.limit || 4;
      const intent = mount.dataset.intent || 'related';

      const url =
        `${window.Shopify.routes.root}recommendations/products` +
        `?section_id=${encodeURIComponent(sectionId)}` +
        `&product_id=${encodeURIComponent(productId)}` +
        `&limit=${encodeURIComponent(limit)}` +
        `&intent=${encodeURIComponent(intent)}`;

      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return;

      const html = await res.text();
      mount.innerHTML = html;
    } catch (e) {
      // do nothing
    } finally {
      isRefreshing = false;
    }
  }

  function setupObservers() {
    // If the drawer/mount is injected later, fill it as soon as it appears
    const rootObserver = new MutationObserver(() => {
      const mount = document.getElementById('CartDrawerRecommendationsMount');
      if (mount && mount.innerHTML.trim() === '') refreshRecommendations();
    });

    rootObserver.observe(document.documentElement, { childList: true, subtree: true });

    // When drawer is interacted with, refresh shortly after (helps with some app flows)
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.addEventListener('click', function () {
        window.setTimeout(() => refreshRecommendations(), 600);
      });
    }
  }

  function hookIntoFetch() {
    const originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function () {
      const args = arguments;
      const url = args[0];

      const urlStr =
        typeof url === 'string'
          ? url
          : (url && url.url) ? url.url : '';

      const isCartCall =
        urlStr.includes('/cart/add') ||
        urlStr.includes('/cart/change') ||
        urlStr.includes('/cart/update') ||
        urlStr.includes('/cart/clear');

      return originalFetch.apply(this, args).then(function (response) {
        if (isCartCall) {
          // Refresh after the cart request completes
          window.setTimeout(() => refreshRecommendations(), 250);
        }
        return response;
      });
    };
  }

  function hookIntoXHR() {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isCartCall =
        typeof url === 'string' &&
        (url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear'));
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__isCartCall) {
        this.addEventListener('loadend', function () {
          window.setTimeout(() => refreshRecommendations(), 250);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupObservers();
    hookIntoFetch();
    hookIntoXHR();

    // Initial fill
    refreshRecommendations();
  });

  // Keep these too (nice when the theme events do fire)
  document.addEventListener('cart:change', function (event) {
    if (event && event.detail && event.detail.cart) refreshRecommendations(event.detail.cart);
    else refreshRecommendations();
  });

  document.addEventListener('variant:add', function (event) {
    if (event && event.detail && event.detail.cart) refreshRecommendations(event.detail.cart);
    else refreshRecommendations();
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    refreshRecommendations();
  });
})();